export default __webpack_public_path__ + "static/media/bell.e9e894ca.svg";